import { render } from "./InvoicesPage.vue?vue&type=template&id=555310fd&scoped=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&lang=js"

import "./InvoicesPage.vue?vue&type=style&index=0&id=555310fd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src616941895/src/front-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555310fd"]])

export default __exports__